function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by pzf on 18/9/1.
 *
 */
import Trigger from 'rc-trigger';
import React from 'react';
import { BUILT_IN_PLACEMENTS, POPUP_PLACEMENT, POPUP_ALIGN } from './constant';
Trigger.displayName = 'Trigger';

var PopeditTrigger = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PopeditTrigger, _React$PureComponent);

  function PopeditTrigger() {
    _classCallCheck(this, PopeditTrigger);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopeditTrigger).apply(this, arguments));
  }

  _createClass(PopeditTrigger, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onDropdownVisibleChange = _this$props.onDropdownVisibleChange,
          children = _this$props.children,
          disabled = _this$props.disabled,
          popup = _this$props.popup,
          visible = _this$props.visible,
          placement = _this$props.placement,
          getPopupContainer = _this$props.getPopupContainer;
      return React.createElement(Trigger, {
        showAction: disabled ? [] : ['click'],
        hideAction: ['click'],
        popupPlacement: placement,
        builtinPlacements: BUILT_IN_PLACEMENTS,
        prefixCls: "mkui-popedit-dropdown-wrapper",
        popup: popup,
        mask: true,
        getPopupContainer: getPopupContainer,
        onPopupVisibleChange: onDropdownVisibleChange,
        popupVisible: visible,
        popupAlign: POPUP_ALIGN
      }, children);
    }
  }]);

  return PopeditTrigger;
}(React.PureComponent);

_defineProperty(PopeditTrigger, "defaultProps", {
  placement: POPUP_PLACEMENT,
  getPopupContainer: function getPopupContainer() {
    return document.body;
  }
});

export { PopeditTrigger as default };
PopeditTrigger.displayName = 'SelectTrigger';
//# sourceMappingURL=PopeditTrigger.js.map
